"use client";
import {  useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Button } from '../../../components/ui/button';
import { Link, useLocation } from 'react-router-dom';

const navigation = [
  { name: 'Home', href: '/', withLinks: false },
  { name: 'About Us', href: '/about-us', withLinks: false },
  { name: 'Features', href: '/features', withLinks: false },
  { name: 'Case Precedents', href: '/case-precedents', withLinks: false },
  { name: 'Get Involved', href: '/get-involved', withLinks: false },
  { name: 'FAQs', href: '/faqs', withLinks: false },
  { name: 'Contact Us', href: '/contact-us', withLinks: false },
]

export default function PageHeader(){
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const router = useLocation().pathname;
    return (
        <header style={{ zIndex: 9999}} className={`inset-x-0 top-0 z-50 border-b border-green-200 sticky bg-white`}>
        <nav className="flex items-center justify-between p-2 lg:px-6" aria-label="Global">
            <Link to={"/"} className="flex lg:flex-1 gap-x-2 items-center">
              <img
                className="h-14 w-auto"
                src="/ICON2.png"
                alt="Logo"
              />
              <p className='font-semibold hidden md:block leading-6 uppercase text-gray-950'>
              Wildlife Information & <br /> Tracking System(WITS)
              </p>

              <p className='font-semibold md:hidden leading-6 uppercase text-gray-950'>
              WITS
              </p>

              </Link>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
                <Link key={item.name} to={item.href} title={item.name} aria-label={item.name} className={`leading-6 ${router === item.href ? "text-green-400 underline" : "text-gray-950"} text-light font-light`}>
                {item.name}
              </Link>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end items-center gap-x-3">
                <Link to="/report-incident" className="text-sm font-semibold leading-6 text-gray-950">
                    Report an Incident <span aria-hidden="true">&rarr;</span>
                </Link>
                <Button onClick={() => window.location.href ="/accounts/login"} className='rounded-full' size={"lg"}>
                                Login &rarr;
                              </Button>
          </div>
        </nav>
        <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-green-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">WITS</span>
                <img
                className="h-14 w-auto"
                src="/logo.png"
                alt="Logo"
              />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-white"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      title={item.name}
                      aria-label={item.name}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:bg-orange-600"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                <div className="py-6">
  
                  <a
                    href="/accounts/register"
                    className="inline-flex justify-center items-center py-2.5 px-3 rounded-full text-base font-medium text-center text-white hover:bg-orange-900 focus:ring-4 focus:ring-gray-400 bg-orange-600"
                  >
                   Login &rarr;
                  </a>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    )
}